import EmailTableCard from "./EmailTableCard";

export default EmailTableCard;
